/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// Harvester picks up the intlMessages variable name
/* eslint-disable max-len, sort-keys */
const intlMessages = {
  'error.not_found.description': {
    defaultMessage: 'This page isn\'t available. Try checking the URL or visit a different page.',
    messageId: 'error.not_found.description'
  },
  'error.not_found.heading': {
    defaultMessage: 'Error 404: Page not found',
    messageId: 'error.not_found.heading'
  },
  'error.unknown.heading': {
    defaultMessage: 'Failed to load page',
    messageId: 'error.unknown.heading'
  },
  'error.unknown.refreshBtn': {
    defaultMessage: 'Refresh',
    messageId: 'error.unknown.refreshBtn'
  },
  'error.unknown.description': {
    defaultMessage: 'The page isn\'t loading correctly. Please check your login and try again.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}',
    messageId: 'error.unknown.description'
  },
  'error.rate_limit.description': {
    defaultMessage: 'We\'re experiencing high volumes. Please reload the page or try again in a few minutes.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}',
    messageId: 'error.rate_limit.description'
  },
  'error.rate_limit.heading': {
    defaultMessage: 'Error 429: Rate limited',
    messageId: 'error.rate_limit.heading'
  },
  'error.rate_limit.refreshBtn': {
    defaultMessage: 'Refresh',
    messageId: 'error.rate_limit.refreshBtn'
  },
  'error.timeout.description': {
    defaultMessage: 'This page was not able to load. Try refreshing or visit a different page.\nIf you continue to get this message, contact customer care and reference:\nEIM Instance Id {instanceId}',
    messageId: 'error.timeout.description'
  },
  'error.timeout.heading': {
    defaultMessage: 'Error 408: Request timeout',
    messageId: 'error.timeout.heading'
  },
  'error.timeout.refreshBtn': {
    defaultMessage: 'Refresh',
    messageId: 'error.timeout.refreshBtn'
  },
  'error.offline.heading': {
    defaultMessage: 'No internet connection',
    messageId: 'error.offline.heading'
  },
  'error.offline.description': {
    defaultMessage: 'Check your internet connection and refresh the page',
    messageId: 'error.offline.description'
  },
  'error.cookie_needed.heading': {
    defaultMessage: 'Cookies are blocked',
    messageId: 'error.cookie_needed.heading'
  },
  'error.cookie_needed.description': {
    defaultMessage: 'Your browser is set to block cookies and local storage.\nPlease allow cookies in your browser preferences to access Experience Cloud.',
    messageId: 'error.cookie_needed.description'
  },
  'error.cookie_needed.refreshBtn': {
    defaultMessage: 'Refresh',
    messageId: 'error.cookie_needed.refreshBtn'
  }
};

export {intlMessages as default};
